import { render, staticRenderFns } from "./Remove.vue?vue&type=template&id=3f470d12&"
var script = {}


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/skysql-ui-client/skysql-ui-client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3f470d12')) {
      api.createRecord('3f470d12', component.options)
    } else {
      api.reload('3f470d12', component.options)
    }
    module.hot.accept("./Remove.vue?vue&type=template&id=3f470d12&", function () {
      api.rerender('3f470d12', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/icons/Remove.vue"
export default component.exports